import { TableContainer } from "@mui/material";
import { Table } from "antd";
import React, { useState } from "react";
import ExportToExcel from "~/components/ExportToExcel";

const PlotData = (data) => {
  console.log(data, "dayta")
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 25,
    },
  });

  const columns = [
    {
      title: "Plotting Name",
      dataIndex: "Plot_Name",
      key: "Plot_Name",
      responsive: ["lg", "md", "xl", "sm"],
    },
    {
      title: "Plotting Code",
      dataIndex: "Plot_Code",
      key: "Plot_Code",
      responsive: ["lg", "md", "xl", "sm"],
    },
    {
      title: "Location name",
      dataIndex: "Loc_Name",
      key: "Loc_Name",
      responsive: ["lg", "md", "xl", "sm"],
    },
    {
      title: "Total plotting area (ha)",
      dataIndex: "Plot_Area",
      key: "Plot_Area",
      responsive: ["lg", "md", "xl", "sm"],
    },
    {
      title: "Total number of planting",
      dataIndex: "Total_Planting_Count",
      key: "Total_Planting_Count",
      responsive: ["lg", "md", "xl", "sm"],
    },
    {
      title: "Land use",
      dataIndex: "Land_Use",
      key: "Land_Use",
      responsive: ["lg", "md", "xl", "sm"],
    },
    {
      title: "Aspect",
      dataIndex: "Aspect",
      key: "Aspect",
      responsive: ["lg", "md", "xl", "sm"],
    },
    {
      title: "Soil texture",
      dataIndex: "Soil_Texture",
      key: "Soil_Texture",
      responsive: ["lg", "md", "xl", "sm"],
    },
    {
      title: "Presence of weed or grass",
      dataIndex: "Presence_of_Weed_or_Grass",
      key: "Presence_of_Weed_or_Grass",
      responsive: ["lg", "md", "xl", "sm"],
    },
  ];

  return (
    <>
      <ExportToExcel data={data.reportData} columns={columns} fileName="Plot Data.csv" />
      <TableContainer sx={{ boxShadow: "none" }}>
        <Table
          scroll={{
              x: 2000,
              y: 1000,
          }}
          columns={columns}
          dataSource={data.reportData}
          pagination={{
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
          }}
        />
      </TableContainer>
    </>
  );
};

export default PlotData;
